module.exports = __webpack_public_path__ + "img/united2-cover-3.4552b900.jpg";